<!-- ************************************************************************************************************************************* -->
<div cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <div mat-dialog-title class="matDialogTitle" cdkDragHandle>
    <mat-progress-bar mode="indeterminate" [hidden]="!loading" class="detaile"></mat-progress-bar>
    <span *ngIf="lang==1"> پروفایل </span>
    <span *ngIf="lang==2"> Profile </span>
    <span class="close" (click)="close()">
      <mat-icon>close</mat-icon>
    </span>
  </div>
</div>


<form [formGroup]="form1" (ngSubmit)="check_access(type_task,1)">
  <div mat-dialog-content class="matDialogContent" style="padding:0px !important">
    <div class="row">
      <div class='col-md-9 col-lg-9 col-sm-9 col-xs-12 pe' [ngClass]="{en:lang==2,width100:type_task == 3}">
        <div class="row">
          <div class='ol-md-3 col-lg-3 col-sm-4 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}"
            style='margin-top:5px'>
            <label for="group" class='wh-label'>
              <span *ngIf="lang == 1 "> گروههای کاربری :</span>
              <span *ngIf="lang == 2 "> Groups :</span>
              <span (click)="reset_input(23)">
                <mat-icon class="close" class="input_search input_search_pe" [ngClass]="{input_search_en:lang==2}">close
                </mat-icon>
              </span>
              <input class='wh-input' formControlName='group_title' autocomplete="off" (click)="load_services(23)"
                [required]="required()" readonly>
              <input class='wh-input' formControlName='group' autocomplete="off" [required]="required()" [hidden]="true"
                readonly>
            </label>
          </div>
          <div class='col-md-3 col-lg-3 col-sm-4 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}"
            style='margin-top:5px'>
            <label for="sex" class='wh-label'>
              <span *ngIf="lang == 2">Name :</span>
              <span *ngIf="lang == 1"> عنوان :</span>
              <span (click)="reset_input(214)">
                <mat-icon class="close" class="input_search input_search_pe" [ngClass]="{input_search_en:lang==2}">close
                </mat-icon>
              </span>
              <input class='wh-input' formControlName='sex_title' autocomplete="off" [required]="required()" readonly
                (click)="load_services(214)">
              <input class='wh-input' formControlName='sex' autocomplete="off" [required]="required()" readonly
                [hidden]="true">
            </label>
          </div>
          <div class='col-md-3 col-lg-3 col-sm-4 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}"
            style='margin-top:5px'>
            <label for="title" class='wh-label'>
              <span *ngIf="lang == 2">Name :</span>
              <span *ngIf="lang == 1">نام کاربر :</span>
              <input class='wh-input' formControlName='title' autocomplete="off" [required]="required()">
            </label>
          </div>
          <div class='col-md-3 col-lg-3 col-sm-4 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}"
            style='margin-top:5px'>
            <label for="cellphone" class='wh-label'>
              <span *ngIf="lang == 2">cellPhone :</span>
              <span *ngIf="lang == 1"> شماره همراه :</span>
              <input class='wh-input' formControlName='cellphone' (keypress)="serverService.get_number($event)"
                pattern="[0-9]{1,}" minlength=11 maxlength=11 autocomplete="off" [required]="required()">
            </label>
          </div>
          <div class='ol-md-3 col-lg-3 col-sm-4  col-xs-12 pe div_panding' [ngClass]="{en:lang==2}"
            style='margin-top:5px'>
            <label for="status_id" class='wh-label'>
              <span *ngIf="lang == 1 "> وضعیت :</span>
              <span *ngIf="lang == 2 "> Status :</span>
              <span (click)="reset_input(26)">
                <mat-icon class="close" class="input_search input_search_pe" [ngClass]="{input_search_en:lang==2}">close
                </mat-icon>
              </span>
              <input class='wh-input' formControlName='status_title' autocomplete="off" (click)="load_services(26)"
                [required]="required()" readonly>
              <input class='wh-input' formControlName='status_id' autocomplete="off" [required]="required()"
                [hidden]="true" readonly>
            </label>
          </div>
          <div class='col-md-3 col-lg-3 col-sm-4 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}"
            style='margin-top:5px'>
            <label for="phone" class='wh-label'>
              <span *ngIf="lang == 2">Fix Phone :</span>
              <span *ngIf="lang == 1"> شماره ثابت :</span>
              <input class='wh-input' formControlName="phone" autocomplete="off">
            </label>
          </div>
          <div class='ol-md-3 col-lg-3 col-sm-3  col-xs-12 pe div_panding' [ngClass]="{en:lang==2}"
            style='margin-top:5px'>
            <label for="user" class='wh-label'>
              <span *ngIf="lang == 1 ">شناسه کاربری :</span>
              <span *ngIf="lang == 2 ">User neme :</span>
              <input class='wh-input' formControlName='user' autocomplete="off">
            </label>
          </div>
          <div class='col-md-3 col-lg-3 col-sm-4 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}"
            style='margin-top:5px'>
            <label for="email" class='wh-label'>
              <span *ngIf="lang == 2">Email :</span>
              <span *ngIf="lang == 1"> پست الکترونیک :</span>
              <input class='wh-input' style="direction:ltr" formControlName='email' autocomplete="off">
            </label>
          </div>

          <div class='col-md-3 col-lg-3 col-sm-4 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}"
            style='margin-top:5px'>
            <label for="site" class='wh-label'>
              <span *ngIf="lang == 2">Site :</span>
              <span *ngIf="lang == 1"> سایت :</span>
              <input type="url" class='wh-input ' style="direction:ltr" formControlName='site' autocomplete="off"
                placeholder="https://x.com" pattern="https://.*">
            </label>
          </div>


          <div class='col-md-6 col-lg-6 col-sm-6 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}"
            style='margin-top:5px'>
            <label for="address" class='wh-label'>
              <span *ngIf="lang == 2">Address :</span>
              <span *ngIf="lang == 1"> آدرس :</span>
              <input class='wh-input' formControlName='address' autocomplete="off">
            </label>
          </div>

          <div class='col-md-3 col-lg-3 col-sm-4 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}"
            style='margin-top:5px' [hidden]="type_task == 3">
            <label for="title" class='wh-label'>
              <span *ngIf="lang == 2">Password :</span>
              <span *ngIf="lang == 1"> رمز عبور :</span>
              <input type="text" class='wh-input' formControlName='password'>
            </label>
          </div>

          <div class='col-md-3 col-lg-3 col-sm-4 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}"
            style='margin-top:5px'>
            <label for="national_id" class='wh-label'>
              <span *ngIf="lang == 1"> شناسه ملی:</span>
              <span *ngIf="lang == 2">--- :</span>
              <input type="text" class='wh-input' formControlName='national_id' maxlength="11"
                (keypress)="serverService.get_number($event)">
            </label>
          </div>


          <div class='col-md-3 col-lg-3 col-sm-4 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}"
            style='margin-top:5px'>
            <label for="economic_id" class='wh-label'>
              <span *ngIf="lang == 1"> کد اقتصادی:</span>
              <span *ngIf="lang == 2">--- :</span>
              <input type="text" class='wh-input' formControlName='economic_id' maxlength="12"
                (keypress)="serverService.get_number($event)">
            </label>
          </div>

          <div class='col-md-3 col-lg-3 col-sm-4 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}"
            style='margin-top:5px'>
            <label for="post_code" class='wh-label'>
              <span *ngIf="lang == 1"> کد پستی:</span>
              <span *ngIf="lang == 2">--- :</span>
              <input type="text" class='wh-input' formControlName='post_code' maxlength="10"
                (keypress)="serverService.get_number($event)">
            </label>
          </div>

          <div class='col-md-12 col-lg-12 col-sm-12 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}"
            style='margin-top:5px'>
            <label for="title" class='wh-label'>
              <span *ngIf="lang == 2">Comment :</span>
              <span *ngIf="lang == 1"> توضیحات :</span>
              <textarea class="wh-input" formControlName='comment' style="height:80px"></textarea>
            </label>
          </div>
        </div><!-- row -->
      </div><!-- col-md-8 col-lg-8 col-sm-8 col-xs-12  -->

      <div class='col-md-3 col-lg-3 col-sm-3 col-xs-12 pe' [ngClass]="{en:lang==2}" style="padding-top:0.5rem"
        [hidden]="type_task == 3">
        <span>لوگو</span>
        <mat-card class="example-card logo cursor backgroundImage"
          style="padding:3px 16px 7px 16px;width:100%;height:10rem"
          [ngStyle]="{'background-image':'url( ' + user_logo + ')'}" (click)="logo.click()" accept="image/*">
          <mat-card-header style="display:inline" class="pe1" [ngClass]="{en1:lang==2}">
          </mat-card-header>
        </mat-card>
        <span (click)="delete_logo()" *ngIf="user_logo_bin == true"><i class="far fa-trash-alt icon"
            style="margin: 0px 4px;"></i></span>
        <input type="file" (change)="change_avater($event)" style="display: none;" #logo>
      </div><!-- col-md-4 col-lg-4 col-sm-4 col-xs-12 pe  -->
    </div><!-- row -->

    <div class="row">
      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-3 col-xs-12 pe service" *ngFor="let x of list_job"
        style="float: right;">
        <mat-checkbox class="user-checkbox" [value]="x.site_job_id" (change)="change_job()" name="job[]"
          [checked]="x.checked"></mat-checkbox>
        {{ x.site_job_title }}
      </div>
    </div>

    <hr>

    <div class="row">
      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-3 col-xs-12 pe service" *ngFor="let x of list_service">
        <mat-checkbox class="user-checkbox" [value]="x.shop_services_id" (change)="change_select_service()"
          name="service[]" [checked]="x.checked"></mat-checkbox>
        {{ x.shop_services_title }}
      </div>
    </div>

  </div> <!-- content -->


  <div mat-dialog-actions align="start" class="pe1 matDialogActions" [ngClass]="{en1:lang==2}"
    style="padding-right:25px">
    <button type="submit" [disabled]="!form1.valid" class="btn_pe" [ngClass]="{btn_en:lang == 2}"
      *ngIf="type_task == 1 || type_task == 2">
      <span *ngIf="lang == 2">Save</span>
      <span *ngIf="lang == 1">ذخیره</span>
    </button>
    <button type="submit" class="btn_pe" [ngClass]="{btn_en:lang == 2}" *ngIf="type_task == 3">
      <span *ngIf="lang == 2">Search</span>
      <span *ngIf="lang == 1">جستجو</span>
    </button>
    <button type="button" class="btn_pe" [ngClass]="{btn_en:lang == 2}" *ngIf="type_task == 3"
      (click)="check_access(type_task,2)">
      <span *ngIf="lang == 2">Excel</span>
      <span *ngIf="lang == 1">خروجی اکسل</span>
    </button>

  </div><!-- row -->
</form>